export const locations = [
  {
    id: crypto.randomUUID(),
    latlng: [51.533, 7.056],
    email: "info@gw-energienetze.de",
    website: "https://www.gw-energienetze.de",
    isMember: false,
    name: "GELSENWASSER Energienetze GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [54.082, 12.133],
    email: "alexander.christen@swrag.de",
    website: "https://www.swrag.de/",
    isMember: false,
    name: "Stadtwerke Rostock AG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.764, 11.421],
    email: "andreas.schmidt@sw-i.de",
    website: "https://www.sw-i.de/",
    isMember: true,
    name: "Stadtwerke Ingolstadt Beteiligungen GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.359, 13.068],
    email: "anett.seidel@stadtwerke-neustrelitz.de",
    website: "https://www.stadtwerke-neustrelitz.de/privatkunden",
    isMember: false,
    name: "Stadtwerke Neustrelitz GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.508, 10.303],
    email: "barbara.balster@ewerk-sachsenwald.de",
    website: "https://www.ewerk-sachsenwald.de/start",
    isMember: true,
    name: "e-werk Sachsenwald GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.638, 9.826],
    email: "a.liedtke@gwhalstenbek.de",
    website: "https://www.gwhalstenbek.de/",
    isMember: true,
    name: "Gemeindewerke Halstenbek",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.635, 11.406],
    email: "aurel.witt@SWSN.DE",
    website: "https://www.stadtwerke-schwerin.de/",
    isMember: false,
    name: "Stadtwerke Schwerin GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.673, 7.822],
    email: "c.helm@stadtwerke-hamm.de",
    website: "https://www.stadtwerke-hamm.de/privatkunden/startseite",
    isMember: false,
    name: "Stadtwerke Hamm GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.411, 10.858],
    email: "christian.bluemm@erdgas-schwaben.de",
    website: "https://www.erdgas-schwaben.de",
    isMember: true,
    name: "erdgas schwaben gmbh",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.985, 12.452],
    email: "ewa@ewa-altenburg.de",
    website: "https://www.ewa-altenburg.de",
    isMember: true,
    name: "Energie- und Wasserversorgung Altenburg GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.139, 9.226],
    email: "sekretariat@hnvg.de",
    website: "https://www.hnvg.de/",
    isMember: true,
    name: "Heilbronner Versorgungs GmbH (Gas)",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.089, 8.264],
    email: "frank.rolle@eswe.com",
    website: "https://www.eswe-versorgung.de",
    isMember: true,
    name: "ESWE Versorgungs AG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.147, 12.009],
    email: "Krasserm.krasser@s-w-w.com",
    website: "https://www.gasversorgung-wunsiedel.de/startseite.html",
    isMember: true,
    name: "Gasversorgung Wunsiedel GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.984, 9.151],
    email: "stefan.maunz@stwab.de",
    website: "https://www.stwab.de/",
    isMember: true,
    name: "Aschaffenburger Versorgungs GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.703, 9.016],
    email: "h.rummel@stadtwerke-sindelfingen.de",
    website: "https://www.stadtwerke-sindelfingen.de/",
    isMember: true,
    name: "Stadtwerke Sindelfingen GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.962, 9.811],
    email: "heike.diebel@stadtwerke-bebra.de",
    website: "https://www.stadtwerke-bebra.de",
    isMember: true,
    name: "Stadtwerke Bebra GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.276, 7.229],
    email: "info@biosphaeren-sw.de",
    website: "https://www.stadtwerke-bliestal.de/",
    isMember: true,
    name: "Stadtwerke Bliestal GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.276, 7.121],
    email: "info@biosphaeren-sw.de",
    website: "https://www.sw-igb.de/",
    isMember: true,
    name: "Stadtwerk St. Ingbert GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.702, 9.406],
    email: "info@energieried.de",
    website: "https://www.energieried.de/",
    isMember: true,
    name: "ENERGIERIED GmbH & Co. KG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [52.201, 8.542],
    email: "info@ewb.aov.de",
    website: "https://www.ewb.aov.de/impressum.html",
    isMember: true,
    name: "Energie- und Wasserversorgung Bünde GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.972, 8.239],
    email: "info@ewr.de",
    website: "https://www.ewr.de/",
    isMember: false,
    name: "EWR AG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.813, 10.469],
    email: "info@ewsvertrieb.de",
    website: "https://www.ew-segeberg.de/",
    isMember: false,
    name: "Energie und Wasser Wahlstedt/Bad Segeberg GmbH & Co. KG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.898, 10.678],
    email: "info@gemeindewerke-stockelsdorf.de",
    website: "https://www.gemeindewerke-stockelsdorf.de/",
    isMember: true,
    name: "Gemeindewerke Stockelsdorf GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.999, 8.397],
    email: "info@oew-energie.de",
    website: "https://www.erdgas-suedwest.de",
    isMember: true,
    name: "Erdgas Südwest GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.398, 10.604],
    email: "info@ohraenergie.de",
    website: "https://www.ohraenergie.de/",
    isMember: true,
    name: "Ohra Energie GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.319, 8.434],
    email: "info@pfalzgas.de",
    website: "https://www.pfalzgas.de",
    isMember: true,
    name: "Pfalzgas GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.369, 8.749],
    email: "info@stadtwerke-bad-nauheim.de",
    website: "https://www.stadtwerke-bad-nauheim.de/",
    isMember: true,
    name: "Stadtwerke Bad Nauheim GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [54.38, 12.732],
    email: "info@stadtwerke-barth.de",
    website: "https://www.stadtwerke-barth.de/",
    isMember: true,
    name: "Stadtwerke Barth GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.288, 9.101],
    email: "info@stadtwerke-buedingen.de",
    website: "https://www.stadtwerke-buedingen.de/",
    isMember: true,
    name: "Stadtwerke Büdingen",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.911, 13.032],
    email: "info@stadtwerke-demmin.de",
    website: "https://www.stadtwerke-demmin.de/",
    isMember: false,
    name: "Stadtwerke Demmin GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [54.135, 10.618],
    email: "info@stadtwerke-eutin.de",
    website: "https://www.stadtwerke-eutin.de/",
    isMember: false,
    name: "Stadtwerke Eutin GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.871, 11.163],
    email: "info@stadtwerke-gvm.de",
    website: "https://www.stadtwerke-gvm.de/de/start.html",
    isMember: false,
    name: "Stadtwerke Grevesmühlen GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [54.192, 9.094],
    email: "info@stadtwerke-heide.de",
    website: "https://www.stadtwerke-heide.de/index.php",
    isMember: true,
    name: "Stadtwerke Heide GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.463, 12.338],
    email: "info@stadtwerke-malchow.de",
    website: "https://www.stadtwerke-malchow.de/",
    isMember: false,
    name: "Stadtwerke Malchow",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.459, 6.635],
    email: "info@stadtwerke-merzig.de",
    website: "https://www.stadtwerke-merzig.de/",
    isMember: true,
    name: "Stadtwerke Merzig GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [54.131, 9.766],
    email: "info@stadtwerke-nortorf.de",
    website: "https://www.stadtwerke-nortorf.de/index.php/",
    isMember: false,
    name: "Stadtwerke Nortorf AöR",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.203, 7.597],
    email: "info@stadtwerke-pirmasens.de",
    website: "https://www.stadtwerke-pirmasens.de/",
    isMember: true,
    name: "Stadtwerke Pirmasens Holding GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.863, 8.205],
    email: "info@stadtwerke-rastatt.de",
    website: "https://www.stadtwerke-rastatt.de/",
    isMember: false,
    name: "Stadtwerke Rastatt GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.515, 12.693],
    email: "info@stadtwerke-waren.de",
    website: "https://www.stadtwerke-waren.de/",
    isMember: false,
    name: "Stadtwerke Waren GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.757, 9.503],
    email: "info@stadtwerke-wertheim.de",
    website: "https://www.stadtwerke-wertheim.de/willkommen",
    isMember: false,
    name: "Stadtwerke Wertheim GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.276, 8.858],
    email: "info@stadtwerke.balingen.de",
    website: "https://www.stadtwerke.balingen.de",
    isMember: false,
    name: "Stadtwerke Balingen",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.533, 8.355],
    email: "info@stw-frankenthal.de",
    website: "https://www.stw-frankenthal.de/",
    isMember: true,
    name: "Stadtwerke Frankenthal GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.356, 10.223],
    email: "info@stw-winsen.de",
    website: "https://www.stw-winsen.de/",
    isMember: false,
    name: "Stadtwerke Winsen (Luhe) GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.031, 10.528],
    email: "info@stwhas.de",
    website: "https://www.stwhas.de/",
    isMember: true,
    name: "Stadtwerk Haßfurt GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.934, 8.414],
    email: "info@sw-ettlingen.de",
    website: "https://www.sw-ettlingen.de/",
    isMember: false,
    name: "Stadtwerke Ettlingen GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.874, 12.585],
    email: "info@sw-teterow.de",
    website: "https://www.sw-teterow.de/",
    isMember: false,
    name: "Stadtwerke Teterow GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.771, 9.687],
    email: "info@sw-tornesch.com",
    website: "https://www.sw-tornesch.de/",
    isMember: false,
    name: "Stadtwerke Tornesch GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.737, 9.315],
    email: "info@swe.de",
    website: "https://www.swe.de/",
    isMember: false,
    name: "Stadtwerke Esslingen am Neckar GmbH & Co. KG (SWE)",
  },
  {
    id: crypto.randomUUID(),
    latlng: [54.343, 10.086],
    email: "info@vbk-kronshagen.de",
    website: "https://www.vbk-kronshagen.de",
    isMember: false,
    name: "Versorgungsbetriebe Kronshagen GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.416, 9.826],
    email: "info@w2g-energy.de",
    website: "https://www.w2g-energy.de",
    isMember: false,
    name: "Wind to Gas Energy GmbH & Co. KG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.167, 9.375],
    email: "info@wingas.de",
    website: "https://www.wingas.com",
    isMember: true,
    name: "WINGAS GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.485, 8.253],
    email: "j.korschinsky@stadtwerke-weilburg.de",
    website: "https://www.stadtwerke-weilburg.de/",
    isMember: true,
    name: "Stadtwerke Weilburg GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.317, 7.341],
    email: "juergen.schirra@stadtwerke-homburg.de",
    website: "https://www.stadtwerke-homburg.de/startseite",
    isMember: true,
    name: "Stadtwerke Homburg GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [54.314, 13.09],
    email: "julia.romer@energie-stralsund.de",
    website: "https://www.stadtwerke-stralsund.de",
    isMember: false,
    name: "SWS Stadtwerke Stralsund GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.855, 14.431],
    email: "bredemann@spreegas.de",
    website: "https://www.spreegas.de/",
    isMember: true,
    name: "SpreeGas Gesellschaft für Gasversorgung und Energiedienstleistung mbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.716, 8.104],
    email: "kontakt@enwag.de",
    website: "https://www.enwag.de",
    isMember: true,
    name: "enwag energie- und wassergesellschaft mbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.472, 9.667],
    email: "kontakt@stadtwerk-tauberfranken.de",
    website: "https://www.stadtwerk-tauberfranken.de/",
    isMember: true,
    name: "Stadtwerke Tauberfranken GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.243, 7.371],
    email: "kontakt@stadtwerke-zw.de",
    website: "https://www.stadtwerke-zw.de/",
    isMember: true,
    name: "Stadtwerke Zweibrücken GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.632, 11.416],
    email: "kontakt@wemag.com",
    website: "https://www.wemag.com/",
    isMember: false,
    name: "WEMAG AG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.848, 10.706],
    email: "kundenservice@zvo.com",
    website: "https://www.zvo-energie.de/",
    isMember: true,
    name: "ZVO Energie GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.61, 7.223],
    email: "detlev.albert@rhenag.de",
    website: "https://www.rhenag.de",
    isMember: true,
    name: "rhenag Rheinische Energie AG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.74, 12.934],
    email: "Astrid.Eberius@eins.de",
    website: "https://www.eins.de/privatkunden/",
    isMember: true,
    name: "eins energie in sachsen GmbH & Co. KG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.286, 7.163],
    email: "frank.jochum@gaswerk-illingen.de",
    website: "https://www.gaswerk-illingen.de/",
    isMember: true,
    name: "Gaswerk Illingen Zweckverband",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.903, 8.717],
    email: "marketing@gvp-erdgas.de",
    website: "https://www.gvp-erdgas.de",
    isMember: true,
    name: "Gasversorgung Pforzheim Land GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.27, 10.986],
    email: "netze@suec.de",
    website: "https://www.suec.de",
    isMember: true,
    name: "Städtische Werke Überlandwerke Coburg GmbH SÜC Energie und H2O GmbH SÜC Bus und Aquaria GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.753, 9.663],
    email: "oeffentlichkeit@stadtwerke-elmshorn.de",
    website: "https://www.stadtwerke-elmshorn.de/",
    isMember: false,
    name: "Stadtwerke Elmshorn",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.297, 14.286],
    email: "office@linznetz.at",
    website: "https://www.linz-gasnetz.at",
    isMember: true,
    name: "LINZ GAS Netz GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.383, 8.003],
    email: "p.kessler@stadtwerke-diez.de",
    website: "https://www.stadtwerke-diez.de/",
    isMember: true,
    name: "Stadtwerke Diez GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.466, 8.41],
    email: "peter.guenther@sw-freudenstadt.de",
    website: "https://www.stadtwerke-freudenstadt.de/",
    isMember: true,
    name: "Stadtwerke Freudenstadt GmbH & Co. KG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.223, 6.894],
    email: "petra.behrens@stadtwerke-erkrath.de",
    website: "https://www.stadtwerke-erkrath.de/",
    isMember: false,
    name: "Stadtwerke Erkrath GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.656, 9.796],
    email: "post@stadtwerke-pinneberg.de",
    website: "https://www.stadtwerke-pinneberg.de/",
    isMember: false,
    name: "Stadtwerke Pinneberg GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [47.838, 11.146],
    email: "post@stawm.de",
    website: "https://www.stawm.de",
    isMember: false,
    name: "Stadtwerke Weilheim i.OB Kommunalunternehmen (KU)",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.565, 14.381],
    email: "post@swspremberg.de",
    website: "https://www.swspremberg.de/",
    isMember: false,
    name: "Städtische Werke Spremberg",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.141, 11.589],
    email: "verbraucherservice@thuega-energie.de",
    website: "https://www.thuega-energie-gmbh.de",
    isMember: true,
    name: "Thüga Energie GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.347, 12.435],
    email: "Melanie.Hensel@vng.de",
    website: "https://www.vng.de/de",
    isMember: true,
    name: "VNG AG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.095, 9.087],
    email: "doris.kimmel@eva-alzenau.de",
    website: "https://www.eva-alzenau.de",
    isMember: true,
    name: "Energieversorgung Alzenau GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.168, 8.835],
    email: "service@mainkinziggas.de",
    website: "https://www.mainkinziggas.de",
    isMember: true,
    name: "Gasversorgung Main-Kinzig GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.686, 10.157],
    email: "presse@odr.de",
    website: "https://www.odr.de/",
    isMember: true,
    name: "EnBW Ostwürttemberg DonauRies AG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.558, 9.707],
    email: "presse@re-fd.de",
    website: "https://www.re-fd.de",
    isMember: true,
    name: "RhönEnergie Fulda GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.006, 8.679],
    email: "presse@stadtwerke-langen.de",
    website: "https://www.stadtwerke-langen.de/",
    isMember: false,
    name: "Stadtwerke Langen GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.2, 6.69],
    email: "presse@stadtwerke-neuss.de",
    website: "https://www.stadtwerke-neuss.de/",
    isMember: true,
    name: "Stadtwerke Neuss GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [54.296, 9.667],
    email: "presse@stadtwerke-sh.de",
    website: "https://www.stadtwerke-sh.de/presse",
    isMember: true,
    name: "Stadtwerke SH GmbH & Co. KG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [54.521, 9.573],
    email: "presse@stadtwerke-sh.de",
    website: "https://www.schleswiger-stadtwerke.de/content/start/",
    isMember: true,
    name: "Schleswiger Stadtwerke GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.049, 10.226],
    email: "presse@stadtwerke-sw.de",
    website: "https://www.stadtwerke-sw.de/",
    isMember: false,
    name: "Stadtwerke Schweinfurt GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.255, 6.654],
    email: "presse@stm-stw.de",
    website: "https://www.stadtwerke-meerbusch.de/",
    isMember: false,
    name: "Stadtwerke Meerbusch",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.961, 9.143],
    email: "presse@sw-bb.de",
    website: "https://www.sw-bb.de",
    isMember: false,
    name: "Stadtwerke Bietigheim-Bissingen GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [47.765, 9.618],
    email: "presse@tws.de",
    website: "https://www.tws.de/",
    isMember: true,
    name: "Technische Werke Schussental GmbH & Co. KG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.259, 8.795],
    email: "info@ewf.de",
    website: "https://www.ewf.de",
    isMember: true,
    name: "Energie Waldeck-Frankenberg GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [48.111, 11.597],
    email: "Claudia.Torterotot@esb.de",
    website: "https://www.esb.de",
    isMember: true,
    name: "Energie Südbayern GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [52.401, 13.107],
    email: "horst.jordan@e-dis.de",
    website: "https://www.e-dis.de/de.html",
    isMember: true,
    name: "E.DIS AG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.72, 7.128],
    email: "redaktion@stadtwerke-bonn.de",
    website: "https://www.stadtwerke-bonn.de",
    isMember: false,
    name: "Energie- und Wasserversorgung Bonn/Rhein-Sieg GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.867, 8.198],
    email: "rheinhessische@rheinhessische.de",
    website: "https://www.rheinhessische.de/fuer-zu-hause.html",
    isMember: true,
    name: "Rheinhessische Energie- und Wasserversorgungs-GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [51.151, 14.988],
    email: "sacha.caron@stadtwerke-goerlitz.de",
    website: "https://www.stadtwerke-goerlitz.de/privatkunden",
    isMember: true,
    name: "Stadtwerke Görlitz AG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [47.807, 9.031],
    email: "sebastian.dix@stadtwerk-am-see.de",
    website: "https://www.stadtwerk-am-see.de",
    isMember: false,
    name: "STADTWERK AM SEE GMBH & CO. KG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.388, 8.076],
    email: "vanessa.wagner@evl.deMarketing",
    website: "https://www.evl.de/",
    isMember: true,
    name: "Energieversorgung Limburg GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.133, 8.914],
    email: "service@stadtwerke-hanau.de",
    website: "https://www.stadtwerke-hanau.de/",
    isMember: true,
    name: "Stadtwerke Hanau GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.516, 13.989],
    email: "service@stadtwerke-pasewalk.de",
    website: "https://www.stadtwerke-pasewalk.de/home/",
    isMember: true,
    name: "Stadtwerke Pasewalk GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.797, 12.172],
    email: "stadtwerke-guestrow@stwg.de",
    website: "https://www.stadtwerke-guestrow.de/",
    isMember: false,
    name: "Stadtwerke Güstrow GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.34, 7.224],
    email: "stadtwerke@bexbach.de",
    website:
      "https://www.stadtwerke-bexbach.de/de/Privatkunden/Kontakt/Ansprechpartner/",
    isMember: true,
    name: "Stadtwerke Bexbach GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.237, 9.392],
    email: "stadtwerke@neuenstadt.de",
    website: "https://www.stadtwerke-neuenstadt.de/startseite",
    isMember: true,
    name: "Stadtwerke Neuenstadt",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.223, 8.369],
    email: "stadtwerke@stw-ger.de",
    website: "https://www.stw-ger.de/startseite",
    isMember: true,
    name: "Stadtwerke Germersheim GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.429, 11.781],
    email: "stefanie.selms@stadtwerke-parchim.de",
    website: "https://www.stadtwerke-parchim.de/startseite.html",
    isMember: false,
    name: "Stadtwerke Parchim GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.557, 13.236],
    email: "steffi.schwabbauer@neu-sw.de",
    website: "https://www.neu-sw.de",
    isMember: false,
    name: "Neubrandenburger Stadtwerke GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [53.894, 11.463],
    email: "sylvia.bartsch@stadtwerke-wismar.de",
    website: "https://www.stadtwerke-wismar.de/de/Unternehmen/News/",
    isMember: false,
    name: "Stadtwerke Wismar GmbH",
  },
  {
    id: crypto.randomUUID(),
    latlng: [47.992, 7.847],
    email: "Thorsten.Kuhlmann@badenova.de",
    website: "https://www.badenova.de/",
    isMember: true,
    name: "Badenova AG & Co. KG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [50.098, 8.648],
    email: "V.Wasgindt@mainova.de",
    website: "https://www.mainova.de/de/",
    isMember: true,
    name: "Mainova AG",
  },
  {
    id: crypto.randomUUID(),
    latlng: [49.462, 11.006],
    email: "service@infra-fuerth.de",
    website: "https://www.infra-fuerth.de/",
    isMember: true,
    name: "Infra Fuerth",
  },
];